import SearchFilters from './SearchFiltersPageSection';

export default SearchFilters;
